import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './overlayView.scss';

class OverlayView extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.isBodyScrollLocked !== prevState.isBodyScrollLocked) {
            return {
                isBodyScrollLocked: nextProps.isBodyScrollLocked,
            };
        }

        return null;
    }
    constructor(props) {
        super(props);

        this.scrollY = 0;
        this.state = {
            isBodyScrollLocked: this.props.isBodyScrollLocked,
            ownsScroll: false,
        };
    }

    componentDidMount() {
        this.toggleBodyScroll(this.isOverlayActive());
    }

    componentDidUpdate(prevProps, prevState, isOverlayActive) {
        if (prevState.isBodyScrollLocked !== this.state.isBodyScrollLocked) {
            this.toggleBodyScroll(isOverlayActive);
        }
    }

    componentWillUnmount() {
        this.toggleBodyScroll(this.isOverlayActive());
    }

    getSnapshotBeforeUpdate() {
        return this.isOverlayActive();
    }

    saveScrollPosition() {
        this.scrollY = window.pageYOffset;
    }

    restoreScrollPosition() {
        return window.scrollTo(0, this.scrollY);
    }

    isOverlayActive() {
        return document.body.classList.contains(styles.noScroll);
    }

    toggleBodyScroll(isOverlayActive) {
        const body = document.body;
        const { ownsScroll, isBodyScrollLocked } = this.state;
        if (isBodyScrollLocked && !isOverlayActive) {
            this.saveScrollPosition();
            body.classList.add(styles.noScroll);
            this.setState({
                ownsScroll: true,
            });
        } else if (ownsScroll && isOverlayActive) {
            body.classList.remove(styles.noScroll);
            this.restoreScrollPosition();
            this.setState({
                ownsScroll: false,
            });
        }
    }

    render() {
        const {
            children,
            hasBorder,
            includePadding,
            className,
            isTransparent,
            isAboveOverlay,
        } = this.props;
        const overlayClasses = classNames(className, {
            [styles.includePadding]: includePadding,
            [styles.menu]: hasBorder,
            [styles.body]: !hasBorder,
            [styles.transparent]: isTransparent,
            [styles.aboveOverlay]: isAboveOverlay,
        });

        return (
            <div className={overlayClasses} data-tn="modal">
                {children}
            </div>
        );
    }
}

OverlayView.defaultProps = {
    hasBorder: false,
    includePadding: false,
    isBodyScrollLocked: true,
};

OverlayView.propTypes = {
    children: PropTypes.node,
    hasBorder: PropTypes.bool,
    isBodyScrollLocked: PropTypes.bool,
    isTransparent: PropTypes.bool,
    isAboveOverlay: PropTypes.bool,
    includePadding: PropTypes.bool,
    className: PropTypes.string,
};

export default OverlayView;
